import React,{useEffect, useState} from "react";
import { Navigate, useNavigate, Link,useParams } from "react-router-dom";
import { association, officials,rules, officialtest } from "../../apis/urls";
import { $ } from "react-jquery-plugin";
import axios from "axios";
import moment from "moment";
import { Empty, message, Result } from "antd";
import { decode } from "html-entities";
import Userimg2 from '../../assets/userimg.png'



const QuestionSelect =()=> {
    document.body.classList.remove("new-login-wrpr");

    let navigate = useNavigate();
    const [amount, setAmount] = useState(0);
    const [coachName, setCoachName] = useState("")
    const Logout = () => {
        let urole = localStorage.getItem('userrole');
        localStorage.removeItem('coachlogin');


        if(urole === 'SUPERADMIN'){
            localStorage.removeItem('token');
            localStorage.removeItem('username');
            localStorage.removeItem('userid');
            localStorage.removeItem('userrole');
            localStorage.removeItem('test_attempted')
            localStorage.removeItem('association')
            localStorage.removeItem('coachId')

           
            navigate("/admin")

        }else{
        let store = localStorage.getItem('token');
        // console.log('key',store)
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        localStorage.removeItem('userid');
        localStorage.removeItem('userrole');
        localStorage.removeItem('test_attempted')
        localStorage.removeItem('association')

        
        navigate("/rules_list", { replace: true });
        }
        //window.location.href = "gisa/";
    }

    const [ ruleid,setRuleid ] = useState([]);
    const [ rulesData,setRulesData ] = useState([]);


    useEffect( ()=>{
        $('body').removeClass('').addClass('sidebar-collapsed');
        rulesListing();

        let coachId = localStorage.getItem('coachid');
        

    },[])



    let token = "Bearer "+localStorage.getItem('token');
    let tokens = localStorage.getItem('token');
   

    

    const current = new Date();
    const date = `${current.getMonth()}-${current.getDate()}-${current.getFullYear()}`;

    let coachId = localStorage.getItem('coachid');
    console.log("coach id isss",coachId);


    const rulesListing = ()=>{

        if(!coachId || coachId === " " || coachId === null || coachId === "0" || coachId === 0){
            message.success("Authentification Failed")
            navigate("/admin")
        }


        const instance = axios.create({

            baseURL: rules+"/rulepublic/list",

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            console.log('showdatas',response)
            setRulesData(response.data.data)
            
            const coachName = response.data.coachname;
            localStorage.setItem('coachname', coachName);
            setCoachName(coachName);
            
            
           
            
          }).catch((error) =>{
            
            console.log('error',error.message)
            
          });

    }

        const [toggle, setToggle] = useState(true)


        const toggleOpenButton = () => 
        {
            $('body').removeClass('').addClass('sidebar-collapsed sidebar-active');
            setToggle(false)
        };

        const toggleCloseButton = () => 
        {
            $('body').removeClass('sidebar-active').addClass('');
            setToggle(true)

        };

    let resetPassword = () => {
        navigate('/reset_password')
    }



  const coach =  localStorage.getItem('coachname');



    return(
        
        
      
      
   
        
        <div className="wrapper">
        
            <aside className="right-side">
            {
                tokens?
            (<header>
                <div className="title-and-userprofile-wrpr" >
                    <div>
                        
                    </div>
                    <div className="user-profile-wrpr nav navbar-nav">
                        <div className="navbar-collapse">
                            <div className="navbar">
                            
                                <ul className="nav user-profile navbar-nav ml-auto text-right">
                                    <ul className="nav-item user-avatar-items dropdown">
                                        <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="/aaa">
                                                        
                                            <div className="username-and-type">
                                                <span className="loggedinuser">
                                                    <i className="icon-userimage"></i> <span className="username">User</span>
                                                </span>
                                                <span className="usertype">{coachName}</span>
                                            </div>
                                            <div className="profile-pic">
                                                <img src={Userimg2} width="" height="" alt="" />
                                            </div>
                                                            
                                        </a>	

                                        <div className="dropdown-menu dropdown-menu-right">
                                            <button className="dropdown-item" onClick={() => {
                                                const coachId = localStorage.getItem('coachid');
                                                if (coachId) {
                                                    navigate(`/editcoaches/${coachId}`);
                                                }
                                            }}>Edit School</button>
                                            <button className="dropdown-item" onClick={ resetPassword }>Reset Password</button>
                                            <button onClick={Logout} className="dropdown-item" href="#">Logout</button>											
                                        </div>
                                    </ul>
                                </ul>
                            </div>
                        </div> 
                    </div>
                </div>
            </header> ) : null
            }

           
                <div className="content-area rule-select-content" style={{marginTop:'0px'}}>

               {/* <div class="message-one" style={{marginBottom:'15px'}}>
                    <div class="message-box ">
                        <i class=" icon-checkmark4"></i>
                        <div style={{fontFamily:'Montserrat'}}>
                        <h2>You may pay for the test you would like to qualify for.</h2>
                        The test screen will be enabled once you make the payment. You have 2 attempts for each test. If you do not qualify after two attempts, you can re-pay and attempt the test again.
                        </div>
                    </div>
                    </div> 
                */}
                
                <div className="row rule-select-row" style={{width:'90%', margin:'0 auto'}}>
                    { rulesData?rulesData.map((item,index)=> (

                        <div className="col-md-4 rule-select" style={{display:'flex', justifyContent:"center", paddingBottom:30}}>
                        
                        <div class="product-card">
                            {item.image?
                                <div class="main-images">
                                    <img id="blue" class="blue active" src={item.image?item.image:null} alt="blue" />
                                </div>:
                                <div class="main-images1">
                                    
                                </div>
                            }
                            <div class="card-details" style={{marginTop:"15px"}}>
                            <span class="card_name" style={{textTransform:'uppercase'}}>{decode(item.rule_name)}</span>
                            </div>


                            <div class="color-price" style={{marginTop:"10px"}}>
                            <div class="color-option">
                                <span class="color" style={{fontFamily:'Poppins', fontSize:15}}><i className="icon-date_range" style={{color:'#1890b3'}}></i></span>
                                <div class="circles">
                                <span style={{fontFamily:'Poppins', fontSize:15}}>Test Closes: {moment(item.testLastDate).format('ddd, MMM DD, YYYY')}</span>
                                </div>
                            </div>
                            </div>
                            {/* icon-checkmark3 */}
                            <div class="color-price">
                                <div class="color-option">
                                    <span class="color" style={{fontFamily:'Poppins', fontSize:15}}><i className="icon-baseball" style={{color:'#1890b3'}}></i></span>
                                    <div class="circles">
                                    <span style={{fontFamily:'Poppins', fontSize:15}}>{item.sport_name}</span>
                                    </div>
                                </div>
                                { /*
                                <div class="price">
                                    <span class="price_num">${item.amount}</span>
                                </div> 
                               */ }
                            </div>



                            <div class="color-price">
                                <div class="color-option">
                                    <span class="color" style={{fontFamily:'Poppins', fontSize:15}}><i className="icon-tick" style={{color:'#1890b3', fontSize:18}}></i></span>
                                    <div class="circles">
                                        <span style={{fontFamily:'Poppins', fontSize:15}}>{item.min_mark} Mark</span>
                                    </div>
                                </div>
                                { /*
                                    tokens ? (
                                    <div class="price">
                                        <span class="price_nums" style={{fontFamily:'Poppins', fontSize:15}}>
                                            {item.test_attempted === 0 ? "2 attempts remaining" : item.test_attempted === 1 && item.status === "FAIL" ? "1 attempt remaining" : item.test_attempted === 1 && item.status === "PASS" ? "" : item.test_attempted === 2 ? "" : ""}
                                        </span>
                                    </div>
                                    ) : null
                                    */ }
                            </div>

                            {
                                tokens ? (
                                    <div class="button">
                                    <div class="button-layer"></div>
                                
                                        <button
                                        
                                        // onClick={()=>!item.payment_status&& !item.status?navigate('/payment/' + item.id + '/' + item.amount):
                                        //     item.payment_status ==="PAID" && item.status === "NOTSTART"?navigate('/questions/'+item.id):
                                        //     item.status === "PASS"?navigate('/certificate/'+item.id):
                                        //     item.status === "FAIL" && item.test_attempted < 2?navigate('/questions/'+item.id):
                                        //     item.status === "FAIL" && item.test_attempted >= 2?navigate('/payment/' + item.id + '/' + item.amount):
                                        //     item.payment_status ==="NOTPAID" && item.status === "NOTSTART"?navigate('/payment/' + item.id + '/' + item.amount):""} 
                                        onClick={() => {
                                            if (!item.status) {
                                                localStorage.setItem('ruleamount', item.amount);
                                                navigate('/questions/' + item.id);
                                            } else if (item.status === "NOTSTART") {
                                                navigate('/questions/' + item.id);
                                            } else if (item.status === "PASS") {
                                                navigate('/certificate/' + item.id);
                                            } else if (item.status === "FAIL" && item.test_attempted < 2) {
                                                navigate('/questions/' + item.id);
                                            } else if(item.test_attempted >= 2 && item.status === "FAIL" && item.reattempt === "ACTIVE")
                                            {
                                                navigate('/questions/' + item.id);
                                            }
                                            
                                        }}
                                        
                                        >
                                            

                                            {
                                                !item.status ? "Test" : // Test Attempt
                                                item.status === "NOTSTART" ? "Test" : // Test Attempt
                                                item.status === "PASS" ? "Certificate" : // Certificate download
                                                item.status === "FAIL" && item.test_attempted < 2 ? "Try Again" : // 2nd chance Attempt
                                                item.test_attempted >= 2 && item.status === "FAIL" && item.reattempt === "INACTIVE" ? "Test chance over" : 
                                                item.test_attempted >= 2 && item.status === "FAIL" && item.reattempt === "ACTIVE" ? "Try Again" : ""
                                            }
                                        </button>
                                    
                                    </div>
                                ) : null
                            }
                        </div>             
                        </div>                    

                    )):
                    <div className="nodata comingroot" style={{margin:"0 auto"}}>
                        <Empty style={{color:'#afafaf', fontWeight:900, fontSize:30}} description="Sorry! No Rules found" />
                    </div>
                    }
                </div>
                        

                </div>
            </aside>

        </div>

    )

}

export default QuestionSelect
